import { render, staticRenderFns } from "./AdminHomeAttivita.vue?vue&type=template&id=47389e84&"
import script from "./AdminHomeAttivita.vue?vue&type=script&lang=js&"
export * from "./AdminHomeAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports